import {
  Button,
  Card,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import SCDegreeCollege from './StudyCertificates/SCDegreeCollege';
import SCDegreeCollegeEmpty from './StudyCertificates/SCDegreeColllegeEmpty';
import SCJuniorCollege from './StudyCertificates/SCJuniorCollege';
import SCJuniorCollegeEmpty from './StudyCertificates/SCJuniorCollegeEmpty';
export default function SCPage() {
  let { instituteType } = useSelector((state) => {
    return state.auth?.successData?.userDetails ?? {};
  });
  const [StudentId, setStudentId] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [emptySC, setEmptySC] = useState(false);
  return (
    <>
      {' '}
      <Card className='max-w-5xl p-4 border-t '>
        <div className='max-w-5xl pb-6 '>
          <Typography variant='h6' className='text-blue-600'>
            {' '}
            Search Student
          </Typography>
          <Card className='p-4 mb-4 border rounded '>
            <Typography variant='body1' className='mb-2'>
              Enter Student Id and search for managing the Study Certificate
              Details.
            </Typography>
            <div className='flex flex-wrap items-end gap-2'>
              <TextField
                value={searchValue}
                id='studentId'
                size='small'
                label='Student Id'
                className='mt-2 mr-10 w-60'
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      {!!searchValue && (
                        <IconButton
                          onClick={() => {
                            setSearchValue('');
                            setStudentId('');
                          }}
                        >
                          <CloseIcon></CloseIcon>
                        </IconButton>
                      )}
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => setSearchValue(e.target.value)}
              ></TextField>

              <Button
                variant='contained'
                disabled={!searchValue}
                onClick={() => {
                  setStudentId(searchValue);
                  setEmptySC(false);
                }}
              >
                Search
              </Button>
            </div>
          </Card>
          {!StudentId && !emptySC && (
            <>
              <b className='text-red-600'> Note : </b>To issue Study Certificate
              manually{' '}
              <b
                className='text-blue-600 hover:underline hover:cursor-pointer'
                onClick={() => {
                  setEmptySC(true);
                  setStudentId('');
                }}
              >
                click
              </b>{' '}
              here.
            </>
          )}
        </div>{' '}
        {!emptySC && (
          <Typography variant='h6' className='text-blue-600'>
            {' '}
            Study Certificate Details :
          </Typography>
        )}
        {emptySC && (
          <>
            <div className='flex justify-between'>
              {' '}
              <Typography variant='h6' className='text-blue-600'>
                {' '}
                Issue Study Certificate Manually :
              </Typography>{' '}
              <Tooltip title='Close'>
                <IconButton
                  onClick={() => {
                    setEmptySC(false);
                    setStudentId('');
                  }}
                >
                  <CloseIcon color='primary' className='text-3xl'></CloseIcon>
                </IconButton>
              </Tooltip>
            </div>
          </>
        )}
        {!emptySC && instituteType?.toLowerCase() === 'college' && (
          <SCDegreeCollege StudentId={StudentId} />
        )}
        {emptySC && instituteType?.toLowerCase() === 'college' && (
          <SCDegreeCollegeEmpty />
        )}
        {!emptySC && instituteType?.toLowerCase() !== 'college' && (
          <SCJuniorCollege StudentId={StudentId} />
        )}
        {emptySC && instituteType?.toLowerCase() !== 'college' && (
          <SCJuniorCollegeEmpty />
        )}
      </Card>
    </>
  );
}
